import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { AnalyzeService } from '../../_services/Analyze/analyze.service';


export const orientationAction = {
    orientationAPI_action
}


function orientationAPI_action(callBack) {
    return dispatch => {
        dispatch(request());
        AnalyzeService.orientationAPI_service()
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_ORIENTATION_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_ORIENTATION_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ORIENTATION_DATA_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/orientationAction.action.js